import { DatePicker as AntDatePicker } from "antd";
import moment from "moment";
import React, { useContext } from "react";
import styled from "styled-components";

import { PPressContextParams, PpressContext, OnChangeTrigger } from "../context";

// Alias for compatibility
const CoeffDatePicker = AntDatePicker;

interface PPressDatepickerProps {
  name: string;
  format?: string;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  className?: string;
  allowClear?: boolean;
  keepTimezoneOffset?: boolean;
  triggersOnChange?: Array<OnChangeTrigger>;
}

const StyledDatePicker = styled(CoeffDatePicker)`
  width: 100%;
  border-radius: 4px;
  border-width: 2px;
  border-right-width: 2px !important;
`;

export const DatePicker = (props: PPressDatepickerProps) => {
  const form_state = useContext(PpressContext) as PPressContextParams;

  return (
    <StyledDatePicker
      className="coeff__ppress_datepicker"
      value={props.value ? moment(props.value) : null}
      format={props.format ?? "MM/DD/YYYY"}
      disabled={props.disabled}
      placeholder={props.placeholder}
      onChange={e => {
        form_state.updatePPressParams({
          [props.name]: e?.toISOString(props.keepTimezoneOffset),
        });
        if (props.triggersOnChange) {
          form_state.triggersOnChange(props.triggersOnChange);
        }
      }}
      allowClear={props.allowClear === undefined ? true : !!props.allowClear}
      data-test-id={`ppress-date-picker-${props.name}`}
    />
  );
};
